module.exports = __webpack_public_path__ + "img/07.c4e79bf7.jpg";